import { Client } from '../../shared/types'
import { useObjectGetBatched } from '../api/object'

export function getClientLabel(client?: Pick<Client, 'name'>) {
	if (!client) return ''
	return client.name
}

export function ClientFormatter({ id }: { id?: string }) {
	const { data: client } = useObjectGetBatched('client', id)

	if (!id) return <em className="text-gray-400">nevyplněno</em>

	return <>{getClientLabel(client)}</>
}
